import script from "./ValueSeriesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ValueSeriesTable.vue?vue&type=script&setup=true&lang=ts"

import "./ValueSeriesTable.vue?vue&type=style&index=0&id=22348bb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22348bb6"]])

export default __exports__